<div class="container">
  <div class="row">
    <div class="card shadow-sm mb-0">
      <div class="card-body">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <p class="fs-6">
              Choose your five favorite stories to get started! Check the box
              next to the story idea. Your other ideas will not be deleted, just
              saved for another day. You will be able to access them at the end
              of the guide.
            </p>
            <h2 class="title text-center my-4">My Brainstorms</h2>
            <form [formGroup]="brainstormForm" (ngSubmit)="onSubmit()">
              <div
                class="card p-4 fs-6"
                *ngFor="let item of items; let i = index">
                <div class="row align-items-center">
                  <div class="col-1 d-flex align-items-center">
                    <div class="styled-checkbox">
                      <input
                        type="checkbox"
                        id="checkbox-story-141"
                        class="form-check-input"
                        [value]="i" />
                    </div>
                  </div>
                  <div class="col-10">
                    <label class="mb-0" for="checkbox-story-141">{{
                      item.label
                    }}</label>
                  </div>
                </div>
              </div>

              <!-- <button class="btn btn-primary" type="submit">
                Continue to step 3
              </button> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
